//
// README
//
// This is a Cadence component built for an active holistic redesign but not meant to be used
// outside the Cadence team (thus the lack of RC prefix and it being in a "temp" dir).
//
// Please reach out to #design-systems if you have any questions or concerns with this component.
//

import React from 'react';
import Helmet from 'react-helmet';
import { RCSwitch } from '../..';

export function RCThemeSwitch() {
  const [themeKey, updateThemeKey] = React.useState('');
  const REVERB_2_THEME = 'web-light-2';

  const updateTheme = React.useCallback((themeName) => {
    updateThemeKey(themeName);
    setElementAttribute(themeName);
    localStorage.setItem('reverb-theme', themeName);
  }, []);

  React.useEffect(() => {
    const localStorageKey = localStorage.getItem('reverb-theme');

    if (localStorageKey) {
      updateTheme(localStorageKey);
    }
  }, [updateTheme]);

  function setElementAttribute(themeName) {
    // eslint-disable-next-line prefer-destructuring
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.setAttribute('data-theme', themeName);
  }

  function handleToggle() {
    if (themeKey === REVERB_2_THEME) {
      updateTheme('');

      return;
    }

    updateTheme(REVERB_2_THEME);

    return;
  }

  return (
    <>
      {/* To ensure the Google Font call only happens when this component is rendering */}
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap" rel="stylesheet" />
      </Helmet>

      <div className="rc-theme-switch">
        <RCSwitch
          checked={themeKey === REVERB_2_THEME}
          label="2.0 Styles"
          onChange={handleToggle}
          id="theme-switch-footer"
        />
      </div>
    </>
  );
}
